import SideMenu from "../components/common/SideMenu";
import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Box, CssBaseline } from "@mui/material";
import { getEncryptedStorageValue } from "../utils/helper";
import { onMessage } from "firebase/messaging";
import { messaging } from "../notifications/firebase";
import { useNavigate } from "react-router";

export function BasicLayout({ children, isShowNotifications}) {
  const navigate = useNavigate();
  const refreshToken = getEncryptedStorageValue("refreshToken");
  const [showNotifications, setShowNotifications] = useState(isShowNotifications);
  
  const theme = createTheme({
    typography: {
      fontFamily: '"Inter", sans-serif !important',
    },
  });

  useEffect(() => {
    if (!refreshToken) {
      navigate("/")
    }
    // eslint-disable-next-line
  }, [refreshToken]);

  useEffect(() => {
    onMessage(messaging, (payload) => {
      localStorage.removeItem("isClicked");
      localStorage.setItem("isReload", true);
      localStorage.setItem("notifications", true);
      setShowNotifications(true);

      const notificationTitle = payload.data.title || "A2b";
      const notificationOptions = {
        body: payload.data?.body,
        icon: payload.data?.image,
      };

      if (!("Notification" in window)) {
        console.log("This browser does not support system notifications");
      } else if (Notification.permission === "granted") {
        const urlToOpen =
          window.location.origin +
            "/packagedetails/" +
            payload?.data?.jobId || "http://localhost:3000/dashboard";
        var notification = new Notification(
          notificationTitle,
          notificationOptions
        );
        notification.onclick = function (event) {
          event.preventDefault();
          window.open(urlToOpen, "_blank");
          notification.close();
        };
      }
    });
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div
          style={{
            display: "flex",
            width: "100vw",
            height: "100vh",
          }}
        >
          <SideMenu showNotifications={showNotifications}/>
          <Box
            component="main"
            sx={{
              backgroundColor: "white",
              paddingTop: 3,
              paddingRight: 3,
              flexGrow: 1,
              overflowY: "auto",
              overflowX: "hidden",
              height: "100vh",
              boxSizing: "border-box",
              marginLeft: `calc(${theme.spacing(28)} + 1px)`,
            }}
          >
            {children}
          </Box>
        </div>
      </ThemeProvider>
    </>
  );
}
